"use client";

import { useCustomEditor } from "@/providers/custom-editor-provider";
import EditorLinkUploadModal from "../editor-link-upload-modal";
import EditorMediaUploadModal from "../editor-media-upload-modal/editor-media-upload-modal";
import ArticleEditorOptions from "./article-editor-options";
import CommentEditorOptions from "./comment-editor-options";
import DiscussionEditorOptions from "./discussion-editor-options";
import AdvancedEditorOptions from "./advanced-editor-options";
import BasicFormattingOptions from "./basic-formatting-options";
import { TPostMedia } from "@/types/post";

const EditorOptions = ({ allowedFormats = [] }: { allowedFormats?: string[] }) => {
	const { editor, editorType, mediaUploaderState, closeMediaUploader, setImages, addInlineMedia } =
		useCustomEditor();

	const isDiscussion = editorType === "discussion";
	const isArticle = editorType === "article";
	const isComment = editorType === "comment";
	const isBasic = editorType === "basic";
	const isAdvanced = editorType === "advanced";

	const handleImagesSelected = (images: Omit<TPostMedia, "id">[]) => {
		mediaUploaderState.isInline ? addInlineMedia(images) : setImages(images);
	};

	if (!editor) return null;

	return (
		<>
			<div className="flex w-full flex-wrap items-center justify-start gap-2">
				{/* Discussion type options */}
				{isDiscussion && <DiscussionEditorOptions allowedFormats={allowedFormats} />}

				{/* Article type options */}
				{isArticle && <ArticleEditorOptions allowedFormats={allowedFormats} />}

				{/* Comment type options */}
				{isComment && <CommentEditorOptions allowedFormats={allowedFormats} />}

				{/* Basic type options */}
				{isBasic && <BasicFormattingOptions allowedFormats={allowedFormats} />}

				{/* Advanced type options */}
				{isAdvanced && <AdvancedEditorOptions allowedFormats={allowedFormats} />}
			</div>

			{/* Modals */}
			<EditorMediaUploadModal
				isOpen={mediaUploaderState.isOpen}
				onClose={closeMediaUploader}
				onImagesSelected={handleImagesSelected}
			/>

			<EditorLinkUploadModal />
		</>
	);
};

export default EditorOptions;
